<template>
  <div>
    <page-steps
      ref="stepper"
      :steps="integration.steps"
      :model="model"
      :rules.sync="rules"
      :save-endpoint="saveEndpoint"
      :readonly="readonly"
      @final-step-updated="updateFinalStep"
      v-if="isStepped"
    />
    <rest-form
      ref="form"
      :save-endpoint="saveEndpoint"
      :model="model"
      :rules="rules"
      :validate-on-rule-change="false"
      :disabled="readonly"
      v-if="model && !isStepped"
    >
      <component
        ref="settings"
        :is="integration.components.settings"
        :model="model"
      />
    </rest-form>
  </div>
</template>

<script>
import RestForm from '@/common/components/rest/RestForm'
import PageSteps from '@/common/components/page/PageSteps'
import { EventBus } from '@/core/EventBus'

export default {
  name: 'IntegrationSettingsForm',

  components: { PageSteps, RestForm },

  data() {
    return {
      rules: {}
    }
  },

  props: {
    integration: {
      type: Object,
      required: true
    },

    model: {
      type: Object,
      required: true
    },

    saveEndpoint: {
      type: Object,
      required: true
    },

    isStepped: {
      default: false,
      type: Boolean
    }
  },
  beforeMount() {
    if (this.integration.hasOwnProperty('steps')) {
      this.integration.steps.forEach(step => {
        if (step.hasOwnProperty('rules')) {
          this.applyTranslations(step.rules)
        }
        step.title = this.$t(step.title)
      })
    }
  },
  mounted() {
    if (this.integration.hasOwnProperty('steps')) {
      let rules = {}
      this.integration.steps.forEach(step => {
        rules = Object.assign(rules, step.rules)
      })
      this.rules = rules
    } else {
      this.rules = this.$refs['settings'].rules
    }

    EventBus.$on('integration-status-changed', status => {
      this.model.active = status
    })

    EventBus.$on('shopify-integration-form-next', event => {
      this.nextStep()
    })
  },
  destroyed() {
    EventBus.$off('shopify-integration-form-next')
  },
  methods: {
    applyTranslations(obj) {
      if (typeof obj === 'object') {
        for (var keys in obj) {
          if (typeof obj[keys] === 'object') {
            this.applyTranslations(obj[keys])
          } else {
            if (keys === 'message') {
              let keyValue = this.$t(obj[keys])
              obj[keys] = keyValue
            }
          }
        }
      }
      return obj
    },
    save() {
      if (this.isStepped) {
        return this.$refs['stepper'].save()
      } else {
        return this.$refs['form'].save()
      }
    },
    updateFinalStep(val) {
      EventBus.$emit('shopify-integration-form-final-step', val)
    },
    nextStep() {
      this.$refs.stepper
        .validate()
        .then(valid => {
          if (valid) {
            this.$refs.stepper.completeStep(
              this.$refs.stepper.currentStep.index
            )
            this.$refs.stepper.proceed({ value: true })
            this.$refs.stepper.nextStep()
          }
        })
        .catch(error => {
          let errors = Object.values(error).map(e => e[0].field)
          return errors
        })
    }
  },

  computed: {
    readonly() {
      return !this.$can('manageProjectTechnical')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/components/IntegrationSettingsForm.vue